import { User } from "./user"
import { Visitor, VisitorCreateDTO } from "./visitor"

export enum ReservationStatus {
    Planned,
    Canceled,
    Completed
}

export enum ReservationType {
    External = 'EXTERNAL',
    Internal = 'INTERNAL'
}

export interface ReservationResourceCustomField {
    customFieldId: string
    value: boolean
    notes?: string
}

export interface ReservationResource {
    resourceId: string
    customFields: ReservationResourceCustomField[]
    startMs: number
    endMs: number
}

export interface ReservationDTO {
    id: string
    title: string
    description: string | null
    attendees: number
    visitors: string[]
    slots: ReservationResource[]
    status: string
    type: string
    createdBy: string
}

export interface CreateReservationDTO {
    title: string
    description: string | null
    attendees: number
    visitors: VisitorCreateDTO[]
    slots: ReservationResource[]
    type: ReservationType
}

export interface Reservation {
    id: string
    title: string
    description: string | null
    attendees: number
    visitors: Visitor[]
    slots: ReservationResource[]
    status: ReservationStatus
    type: ReservationType
    createdBy: User
}